// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__LYAjr"};